import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import * as ProfileActions from '../../profile.actions';

@Component({
  selector: 'app-profile-2fa-help',
  styleUrls: ['./profile-2fa-help.component.scss'],
  templateUrl: './profile-2fa-help.component.html',
  standalone: false
})
export class Profile2FAHelpComponent {
  constructor(private store: Store) {}

  goBack(): void {
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'main' }));
  }
}
